// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"182":"64b24b5b","453":"e8896fdc","522":"a96d74cf"}[chunkId] + ".chunk.js";
};